<template>
    <transition name="slide">
        <section v-if="show"
                 class="z-10 py-2 px-2 md:py-5 bg-brand-gray-800 text-white text-center text-sm md:text-lg lg:text-xl flex flex-col md:flex-row justify-center items-center absolute top-0 left-0 w-full">
            <h1 class="mr-6">Ready to Buy a Hurst Review? Check Out Our Current Offers</h1>
            <a :href="url" class="block rounded-full bg-orange-500 text-brand-gray-800 px-6 py-3">
                Hurst Promo Codes
            </a>
        </section>
    </transition>
</template>

<script>
    export default {
        name: "PromoBanner",

        props: {
            showDuration: {
                type: Number,
                default: 50000,
                required: false
            },
            url: {
              type: String,
              default: 'https://promocode.hurstreview.com/',
              required: false
            }
        },
        data() {
            return {
                show: false
            }
        },

        mounted() {
            setTimeout(() => {
                this.show = true;
            }, 100);
            setTimeout(() => {
                this.show = false;
            }, this.showDuration);
        }
    }
</script>

<style scoped>
    .slide-leave-active,
    .slide-enter-active {
        transition: all .5s ease-in-out;
    }
    .slide-enter {
        opacity: 0;
    }
    .slide-leave-to {
        opacity: 0;
    }
</style>